import { ROUTES } from '../routes/routes.constants';
/**
 * EXTRA_PAGES defines routes that use Context API state management
 * instead of URL query parameters.
 *
 * Add any new routes here to ensure they are handled correctly
 * by state-management hooks and navigation logic.
 */
export const EXTRA_PAGES = [
    ROUTES.accountOverview.path,
    // Add future context-aware pages here
];
/**
 * Helper to check if a given path is an "extra page"
 */
export const isExtraPage = (path) => {
    return EXTRA_PAGES.some(extraPath => {
        // Handle exact matches or base path matches
        const baseExtraPath = extraPath.split('?')[0];
        const basePath = path.split('?')[0];
        return baseExtraPath === basePath;
    });
};
